import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Autoplay, Grid, Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initGridOfDocumentsCards() {
  Alpine.data(
    'gridOfDocumentsCards',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        // @ts-ignore
        const swiperEl = this.$el.querySelector('.gridOfDocumentsCards__sw');
        if (swiperEl) {
          this.initSwiper(swiperEl as HTMLElement);
        }
      },
      initSwiper(domEl) {
        const { size } = domEl.dataset;
        const totalSize = Number(size);
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation, Grid],
          spaceBetween: 0,
          autoHeight: false,
          loop: false,
          slidesPerView: 2,
          grid: {
            rows: Math.ceil(totalSize / 2),
            fill: 'row',
          },
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .swiper-button-next`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .swiper-button-prev`,
          },
          breakpoints: {
            0: {
              grid: {
                rows: 3,
                fill: 'row',
              },
              slidesPerView: 1,
            },
            992: {
              grid: {
                rows: 3,
                fill: 'row',
              },
              slidesPerView: 1,
            },
            1200: {
              slidesPerView: 2,
            },
          },
        });
      },
    }),
  );
}
